export const mapboxToken = process.env.VUE_APP_MAPBOX_TOKEN
export const mapStyle = 'mapbox://styles/olsiapp/ck9zomhdg0e5d1ip7mjwz9nbx'